import React, { useEffect } from "react";
// import { useState } from "react";
// import { HiChatBubbleLeftRight } from "react-icons/hi2";
// import BotpressBot from "../Components/BotpressBot/BotpressBot";
// import "../Components/BotpressBot/BotpressBot.css";
import HeroSlider from "../Components/Home/HeroSlider";
import HomeGuaranteeStrip from "../Components/Home/HomeGuaranteeStrip";
import HomeCinematicHeroSection from "../Components/Home/HomeCinematicHeroSection";
import MarketplaceNewUISectionDiscover from "../Components/Home/MarketplaceNewUI/MarketplaceNewUISectionDiscover";
import MarketplaceNewUISectionOrganizerQR from "../Components/Home/MarketplaceNewUI/MarketplaceNewUISectionOrganizerQR";
import MarketplaceNewUIMerchPreview from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIMerchPreview";
import MarketplaceNewUIPartnerScroller from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIPartnerScroller";
import MarketplaceNewUIFooter from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIFooter";
import { trustBadges } from "../Components/Home/MarketplaceNewUI/marketplaceHomeNewUIMockData";

/**
 * Same marketplace landing as `Home.jsx` (new-ui `MarketplaceHome` parity).
 */
export default function MarketplaceHomePageNewUI() {
  // const [showBot, setShowBot] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="min-h-screen bg-[#0d0d0d] overflow-x-hidden">
      <HeroSlider />
      <HomeGuaranteeStrip />
      <HomeCinematicHeroSection />

      <MarketplaceNewUISectionDiscover />
      <MarketplaceNewUISectionOrganizerQR />

      <section className="bg-[#111] py-10 border-y border-white/5">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
            {trustBadges.map((badge) => (
              <div key={badge.text} className="flex items-center gap-2 text-sm">
                <span className="text-[#00C853]">{badge.icon}</span>
                <span className="text-white/90">
                  <span className="font-black">{badge.bold}</span>
                  <span className="text-white/50 ml-1">{badge.text}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <MarketplaceNewUIMerchPreview />
      <MarketplaceNewUIPartnerScroller />
      <MarketplaceNewUIFooter />

      {/*
      <button type="button" className="instapass-ai-floating-btn" onClick={() => setShowBot(true)} aria-label="Open INSTAPASS AI">
        <HiChatBubbleLeftRight className="instapass-ai-floating-icon" />
        <span className="instapass-ai-tooltip">TALK TO BOT</span>
      </button>
      {showBot ? (
        <>
          <div className="instapass-ai-sidebar-overlay" onClick={() => setShowBot(false)} role="presentation" />
          <div className="instapass-ai-sidebar" onClick={(e) => e.stopPropagation()}>
            <BotpressBot onClose={() => setShowBot(false)} />
          </div>
        </>
      ) : null}
      */}
    </div>
  );
}
